import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useTheme, useStore } from "@/comn/hooks";
import { useEffect, useState } from "react";
import {
    APIS,
    SF_CSTM_OFCR_INFO,
    SG_USR_AUTH_HIST_LIST,
    SG_USR_AUTH_HIST_EXCEL_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/authhist/services/PtliAuthHistService";
import { useNavigate, useParams } from "react-router-dom";
import { comnUtils } from "@/comn/utils";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

/*
 * Select. Custom Office User Auth History Detail
 * !== 세관 사용자 권한 이력 상세 ==!
 */
export const PTLI1009002Q = (): JSX.Element => {
    const modal = useModal();
    const param = useParams();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const [load, setLoad] = useState(false);

    const form = {
        cstmOfcrInfo: useForm({
            defaultSchema: SF_CSTM_OFCR_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        usrAuthHistList: useGrid({ defaultSchema: SG_USR_AUTH_HIST_LIST, page: pgeStore?.page, size: pgeStore?.size }),

        usrAuthHistExcelList: useGrid({
            defaultSchema: SG_USR_AUTH_HIST_EXCEL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmUsrDta: useFetch({
            api: () => APIS.getCstmUsrDta({ usrDmnId: param["usrDmnId"] }),
            onSuccess: (data: any) => {
                const { content } = data.usrInfo;
                form.cstmOfcrInfo.setValues(content);
                fetch.getCstmUsrAuthList.fetch();
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getCstmUsrAuthList: useFetch({
            api: (page = grid.usrAuthHistList.page, size = grid.usrAuthHistList.size) =>
                APIS.getUsrAuthHistList({ usrDmnId: param["usrDmnId"] }, page, size),
            enabled: true,
            key: [grid.usrAuthHistList.page, grid.usrAuthHistList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmOfcrInfo.getValues(),
                    page: grid.usrAuthHistList.page,
                    size: grid.usrAuthHistList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getCstmUsrAuthExcelList: useFetch({
            api: (data: any) => (load ? APIS.getUsrAuthHistExcelList(data) : null),
            enabled: comnUtils.isEmpty(form.cstmOfcrInfo.errors),
            onSuccess: (data) => {
                if (load) {
                    console.log(data);
                    grid.usrAuthHistExcelList.exportExcel({
                        excelName: `${t("L_INT_PTL")}_Internal User Auth History Detail_${t(
                            "T_USR_INFO",
                        )}_${dayjs().format("DD/MM/YYYY HHmm")}`,
                        sheetName: "Sheet1",
                    });
                }
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {};

    useEffect(() => {
        fetch.getCstmUsrDta.fetch();
    }, [theme]);

    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) || load) {
            fetch.getCstmUsrAuthExcelList.fetch(store.form);
        }
    }, [load]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.sctnNm} />
                            <Group.Control {...form.cstmOfcrInfo.schema.cstmNm} />
                            <Group.Control {...form.cstmOfcrInfo.schema.unitNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.usrDmnId} />
                            <Group.Control {...form.cstmOfcrInfo.schema.cstmOfcrNo} />
                            <Group.Control {...form.cstmOfcrInfo.schema.usrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrInfo.schema.usrTelno} />
                            <Group.Control {...form.cstmOfcrInfo.schema.usrEmlAddr} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    setLoad(true);
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Group.Section gap={2}>
                        <Grid {...grid.usrAuthHistList.grid} data={fetch.getCstmUsrAuthList.data?.usrAuthHistList} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Button role={"list"} onClick={() => navigate(`${URLS.ptli1009001q}`)} />
                </Layout.Left>
            </Layout>
            <Group hidden>
                <Grid {...grid.usrAuthHistExcelList.grid} data={fetch.getCstmUsrAuthExcelList.data?.usrAuthHistList} />
            </Group>
        </Page>
    );
};
